import { apiClient } from './client';
import type { BlockedEntity, Blocker, CreateBlockerDto } from '@/types/blocker.types';

class BlockerService {
  async createBlocker(payload: CreateBlockerDto): Promise<Blocker> {
    const response = await apiClient.post('/blockers', payload);
    return response.data.data;
  }

  async listByBlockedEntity(blockedEntity: BlockedEntity, blockedId: number): Promise<Blocker[]> {
    const response = await apiClient.get(`/blockers/${blockedEntity}/${blockedId}`);
    return response.data.data || [];
  }

  async listByCelebration(celebrationId: number): Promise<Blocker[]> {
    const response = await apiClient.get(`/blockers/celebration/${celebrationId}`);
    return response.data.data || [];
  }

  async deleteBlocker(id: number): Promise<void> {
    await apiClient.delete(`/blockers/${id}`);
  }
}

export const blockerService = new BlockerService();
